/**
 * Formats a numeric price into USD currency format.
 *
 * @param price - The price to format, as a number or a preformatted string.
 * @returns The formatted price string, or an empty string if the input is invalid.
 */
const formatUsd = (price: number | string | null | undefined): string => {
  // Sometimes the server sends pre-formatted prices, we want to just pass them through
  if (typeof price === 'string' && price.includes('$')) {
    return price;
  }

  if (price === undefined || price === null) {
    return '';
  }

  return `$${Number.parseFloat(price as string).toFixed(2)}`;
};

export default formatUsd;
